/* eslint-disable */
export default {
  transform: (chunk, { Types, Promise, Mappers, Logger }) =>
    new Promise(resolve => {
      const masterProductMapper = Mappers('masterProduct');
      let distributorMongoId = null;
      const queryBuilderCache = {
        masterProducts: {},
      };
      chunk.forEach(obj => {
        if (distributorMongoId == null) {
          distributorMongoId = new Types.ObjectId(obj.__tmp.dist_id); //eslint-disable-line
        }
        queryBuilderCache.masterProducts[obj.$set.idh] = {
          idh: obj.$set.idh,
        };
      });

      const idhQueryFragment = Object.keys(
        queryBuilderCache.masterProducts,
      ).map(key => queryBuilderCache.masterProducts[key]);
      const masterProductQuery = { $or: idhQueryFragment };

      masterProductMapper
        .find(masterProductQuery)
        .lean()
        .select('_id idh')
        .exec()
        .then(masterProducts => {
          queryBuilderCache.masterProducts = {};
          masterProducts.forEach(masterProduct => {
            queryBuilderCache.masterProducts[masterProduct.idh] = masterProduct._id; //eslint-disable-line
          });

          const newChunk = chunk.map(obj => {
            const newObject = { ...obj };
            if (!newObject.$set) {
              newObject.$set = {};
            }

            newObject.$set.distributor = new Types.ObjectId(newObject.__tmp.dist_id);   //eslint-disable-line
            newObject.$set.dm = new Date();

            if (!newObject.$setOnInsert) {
              newObject.$setOnInsert = {};
            }
            newObject.$setOnInsert.e = true;
            newObject.$setOnInsert.dc = new Date();

            delete newObject.__tmp;  //eslint-disable-line

            const alerts = newObject.$set.alerts;

            if (newObject.$set.idh in queryBuilderCache.masterProducts) {
              newObject.$set.master_product =
                queryBuilderCache.masterProducts[newObject.$set.idh];
            } else {
              alerts.push({code: 'master-product-idh-invalid', level: 'warning'})
            }
            newObject.$set.alerts = alerts;
            return newObject;
          });
          return resolve({ chunk: newChunk });
        });
    }),
};



// WEBPACK FOOTER //
// ./src/configs/etl/products/productsPayloadTransform.js